function isCollectionPreorderForm(productForm) {
  return Boolean(productForm?.classList?.contains('stoq-collection-product-form'));
}

function syncCollectionPreorderForm(productForm) {
  if (!isCollectionPreorderForm(productForm)) return false;

  const form = productForm?.form || productForm?.querySelector?.('.js-product-form');
  const button = form?.querySelector('[name="add"]');
  if (!form || !button) return false;

  const fallback = productForm.parentElement?.querySelector('[data-collection-preorder-fallback]');
  const isReady = button.classList.contains('restock-rocket-preorder-button')
    && Boolean(form.querySelector('[name="selling_plan"]'));
  const isSubmitting = button.classList.contains('is-loading');

  button.disabled = !isReady;
  if (isReady && !isSubmitting) {
    button.removeAttribute('aria-disabled');
  } else {
    button.setAttribute('aria-disabled', 'true');
  }

  productForm.classList.toggle('stoq-collection-product-form--ready', isReady);
  if (fallback) fallback.hidden = isReady;
  return isReady;
}

function watchCollectionPreorderForm(productForm, MutationObserverCtor = globalThis.MutationObserver) {
  if (!isCollectionPreorderForm(productForm)) return null;

  if (!productForm || productForm._binaCollectionPreorderObserver) {
    return productForm?._binaCollectionPreorderObserver || null;
  }

  const form = productForm.form || productForm.querySelector?.('.js-product-form');
  if (!form) return null;

  syncCollectionPreorderForm(productForm);
  if (!MutationObserverCtor) return null;

  const observer = new MutationObserverCtor(() => syncCollectionPreorderForm(productForm));
  observer.observe(form, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
  productForm._binaCollectionPreorderObserver = observer;
  return observer;
}

globalThis.BinaCollectionPreorderForm = {
  sync: syncCollectionPreorderForm,
  watch: watchCollectionPreorderForm
};
